module.exports = __webpack_public_path__ + "static/media/CTLA_4-540w.5f2c46d6.webp";